import { chunk } from 'lodash';

import { BASEURL, ENDPOINTS, SPXAPI } from '../../../../api';
import { FilesListResponse, SharedFile } from '../interfaces';

/** Max file IDs per GET to stay under nginx ~8KB request-line limit (~39 chars per UUID in query). */
export const MAX_FILE_IDS_PER_REQUEST = 80;

/**
 * Fetches file metadata for many IDs by batching GET requests to `files/multiple`.
 */
const fetchFilesChunked = async (API: SPXAPI, filesIds: string[]): Promise<SharedFile[]> => {
    if (!filesIds.length) {
        return [];
    }

    const batches = chunk(filesIds, MAX_FILE_IDS_PER_REQUEST);
    const responses = await Promise.all(
        batches.map(async (batch) => {
            const response: FilesListResponse = await API.get(
                BASEURL.backend(),
                ENDPOINTS.getMultipleFiles(batch),
                {},
            );
            return response;
        }),
    );

    return responses.flatMap(({ files }) => files);
};

export default fetchFilesChunked;
